import { AsyncPipe, NgIf, NgStyle } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  HostBinding,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { BarChartModule } from '@swimlane/ngx-charts';
import { BaseChartDirective } from 'ng2-charts';
import { Observable, map } from 'rxjs';
import { ThemeType } from '../../../core/theme/theme-type';
import { ThemeService } from '../../../core/theme/theme.service';
import { textBlack, textWhite } from '../../../shared/color/color';
import { ChartDataItem, ChartSeriesDataItem } from '../chart-data-item';

// Try apexcharts later.

@Component({
  selector: 'app-bar-chart',
  templateUrl: './bar-chart.component.html',
  styleUrls: ['./bar-chart.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [NgIf, BarChartModule, NgStyle, AsyncPipe],
})
export class BarChartComponent implements OnInit {
  @ViewChild(BaseChartDirective) chart: BaseChartDirective | undefined;

  style$: Observable<CSSStyleDeclaration>;

  ngOnInit(): void {}

  @Input() view: [number, number] = [700, 400];

  @Input() xAxisLabel: string = '';
  @Input() yAxisLabel: string = '';

  @Input() title?: string = '';

  @Input() dataList?: ChartDataItem[];
  @Input() chartSeriesDataItem?: ChartSeriesDataItem[];

  @Input() yScaleMax: any = null;
  @Input() yScaleMin: any = null;

  @Output() onSelect = new EventEmitter<any>();

  @HostBinding('style.width')
  @Input()
  width?: string;

  onSelectChart(item: any) {
    this.onSelect.emit(item);
  }

  constructor(private themeService: ThemeService) {
    this.style$ = this.themeService.onThemeChange$().pipe(
      map(() => {
        const style = {} as CSSStyleDeclaration;

        if (this.themeService.currentTheme === ThemeType.dark) {
          style.fill = textWhite;
        } else {
          style.fill = textBlack;
        }

        return style;
      })
    );
  }

  get customColors() {
    if (this.dataList) {
      return this.dataList.map((c) => ({ name: c.name, value: c.color }));
    } else if (this.chartSeriesDataItem) {
      const result: any[] = [];
      this.chartSeriesDataItem.forEach((c) => {
        c.series.forEach((dataItem) => {
          result.push({ name: dataItem.name, value: dataItem.color });
        });
      });

      return result;
    }

    return [];
  }
}

export enum TableOrChartType {
  table = 'table',
  lineChart = 'lineChart',
  pieChart = 'pieChart',
  barChart = 'barChart',
}

export enum XAxisType {
  assignee = 'assignee',
  creator = 'creator',
  taskType = 'taskType',
  taskStatus = 'taskStatus',
  project = 'project',
  priority = 'priority',
  tag = 'tag',
}

export enum YAxisType {
  taskCount = 'taskCount',
  worklogHours = 'worklogHours',
}
